var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-steps" }, [
    _c("div", { staticClass: "v-steps__main" }, [_vm._t("default")], 2),
    _c("div", { staticClass: "v-steps__lines" }, [
      _c(
        "div",
        { staticClass: "v-steps__lines-wrapper", style: _vm.lineWrapperStyle },
        [
          _vm._l(_vm.steps, function (item, idx) {
            return [
              idx !== _vm.stepsLength - 1
                ? _c(
                    "div",
                    {
                      key: item.index,
                      staticClass: "v-steps__line",
                      class: {
                        "v-steps__line--finish": _vm.active > item.index,
                      },
                      style: _vm.lineStyle,
                    },
                    [
                      _c("div", {
                        staticClass: "v-steps__line-inner",
                        style: _vm.lineInnerStyle,
                      }),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }